import moment from 'moment'

moment.locale('en_US', {
  calendar: {
    sameDay: 'LT',
    lastWeek: 'ddd',
    thisYear: 'MMM DD',
    sameElse: 'DD/MM/YY'
  }
})

moment.calendarFormat = function (myMoment, now) {
  let startOfDay = moment(now).startOf('day')
  let startOfWeek = moment(now).startOf('isoweek')
  let startOfYear = moment(now).startOf('year')

  let retVal = myMoment.isSameOrAfter(startOfDay) ? 'sameDay'
    : myMoment.isSameOrAfter(startOfWeek) ? 'lastWeek'
      : myMoment.isSameOrAfter(startOfYear) ? 'thisYear'
        : 'sameElse'

  return retVal
}

export default moment
